import { Outlet } from "react-router-dom"
import {Header} from "../../components/Header";
import {Footer} from "../../components/Footer";

export const Layout = (props)=>{
    return(
        <div className="page-container">
            <Header></Header>
            <div style={{maxWidth:1444}}>
                <Outlet/>
            </div>
            <Footer></Footer>
        </div>

    )
}
